import { render, staticRenderFns } from "./SayWeeeAuthorize.vue?vue&type=template&id=c3f707b2&scoped=true"
import script from "./SayWeeeAuthorize.vue?vue&type=script&lang=js"
export * from "./SayWeeeAuthorize.vue?vue&type=script&lang=js"
import style0 from "./SayWeeeAuthorize.vue?vue&type=style&index=0&id=c3f707b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f707b2",
  null
  
)

export default component.exports